import { render, staticRenderFns } from "./showError.vue?vue&type=template&id=45c6772e&scoped=true&lang=pug"
import script from "./showError.vue?vue&type=script&lang=js"
export * from "./showError.vue?vue&type=script&lang=js"
import style0 from "./showError.vue?vue&type=style&index=0&id=45c6772e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6772e",
  null
  
)

export default component.exports